import {withStyles, Theme, createStyles} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

interface StyledTabsProps {
  value: number;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}
interface StyledTabProps {
  id: string;
  label: string;
}

export const CustomTabs = withStyles((theme) => ({
  root: {
    borderBottom: '0px',
  },
  indicator: {
    backgroundColor: theme.palette.primary.dark,
  },
}))((props: StyledTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{children: <span />}} />
));

export const CustomTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      minWidth: 72,
      color: theme.palette.grey[600],
      fontWeight: theme.typography.fontWeightMedium,
      marginRight: theme.spacing(4),
      borderRadius: 4,
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: theme.palette.primary.main,
        opacity: 1,
      },
      '&$selected': {
        backgroundColor: 'rgba(44, 145, 56, 0.10)',
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightBold,
      },
      '&:focus': {
        backgroundColor: `rgba(44, 145, 56, 0.10)`,
        color: theme.palette.primary.main,
      },
    },
    selected: {},
  })
)((props: StyledTabProps) => <Tab disableRipple {...props} />);
